import React, { useCallback, useContext, useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { UiButton } from '@shared/ui';

import cls from '../../Files/UI/Modals/ModalFiles.module.css';
import { ModalBody } from '../../Gant/components/UI/Modal/ModalBody/ModalBody';
import { ModalFooter } from '../../Gant/components/UI/Modal/ModalFooter/ModalFooter';
import { MeasuremntsContext } from '../Context/MeasuremntsContext';

export const DeleteImage = ({ onHideModal, onHideSecondModal, isShow }) => {
    const { currentIndex, setImageList, setImagesDelete, imageList } =
        useContext(MeasuremntsContext);

    const { t } = useTranslation();

    const onDeleteImage = useCallback(() => {
        onHideModal();
        const currentImage = imageList.find((image, index) => index === currentIndex);
        if (currentImage && currentImage.id) {
            setImagesDelete((prev) => [...prev, currentImage.id]);
        }
        setImageList((prev) => prev.filter((preview, index) => index !== currentIndex));
    }, [currentIndex, onHideModal, setImageList]);

    const handleEscapeDown = useCallback(
        (event) => {
            if (event.key === 'Escape') {
                onHideSecondModal();
            }
            if (event.key === 'Enter') {
                onDeleteImage();
            }
        },
        [onDeleteImage, onHideSecondModal]
    );

    useEffect(() => {
        if (isShow) {
            const deleteButton = document.querySelector('.deleteButton');
            if (deleteButton) deleteButton.focus();
            document.addEventListener('keydown', handleEscapeDown);
        }
        return () => {
            document.removeEventListener('keydown', handleEscapeDown);
        };
    }, [handleEscapeDown, isShow, onHideSecondModal]);

    return (
        <>
            <ModalBody width="476px" classes={cls.textAlignCenter}>
                {t('DeleteImage.return.ModalBody.confirmationMessage')}
            </ModalBody>
            <ModalFooter classes={cls.textAlignCenter}>
                <UiButton
                    btnText={t('DeleteImage.return.ModalFooter.deleteButton')}
                    btnColor="danger"
                    onClick={onDeleteImage}
                />
                <UiButton
                    btnText={t('DeleteImage.return.ModalFooter.cancelButton')}
                    btnColor="secondary"
                    onClick={onHideSecondModal}
                />
            </ModalFooter>
        </>
    );
};
